﻿<style scoped>
    .control-value {
        padding-top: 7px;
    }
</style>
<template>
    <div class="form-group">
        <label :for="'input'+_uid" class="col-sm-4 control-label"><slot name="name">{{name}}</slot></label>
        <div class="col-sm-8 control-value"><slot name="value">{{value}}</slot></div>
    </div>
</template>

<script>
    module.exports = {
        props: {
            name: {
                type: String,
                required: true
            },
            value: {
                type: String,
                default: ''
            }
        }
    }
</script>